import React from 'react';
import Div from '../../../Element/Div/Div';
import styles from '../../MarginSpace.module.scss';
import { CommonProps } from '../../../Element/Element';

type PanelFooterProps = CommonProps<'div'>;

const PanelFooter: React.FunctionComponent<PanelFooterProps> = ({
  className,
  padding = { size: 'md' },
  children,
  ...props
}) => {
  return (
    <Div
      className={[styles.marginSpace_panel_footer, className]}
      padding={padding}
      backgroundColor="gray100"
      {...props}
    >
      {children}
    </Div>
  );
};

export default PanelFooter;
